import EquipmentPassportPage from '../views/EquipmentPassportPage'
import EquipmentListPage from '../views/EquipmentListPage'
import WorkRequestsListPage from '../views/WorkRequestsListPage'
import WorkRequestPage from '../views/WorkRequestPage.vue'
import WorkRequestAttachments from '../components/simple-forms/WorkRequestAttachments'
import EquipmentAttachments from '../components/simple-forms/EquipmentAttachments'
// import InspectionAttachments from '../components/simple-forms/InspectionAttachments'


import SignInPage from '../views/SignInPage'
// import EquipmentTypesListPage from "../views/EquipmentTypesListPage";
// import EquipmentListPageForInspections from "../views/EquipmentListPageForInspections";
// import EquipmentModelsListPage from "../views/EquipmentModelsListPage";
// import InspectionsListPage from '../views/InspectionsListPage'
// import CurrentInspectionsListPage from '../views/CurrentInspectionsListPage'

// import EquipmentTypeEdit from "../components/forms/EquipmentTypeEdit";
// import EquipmentModelEdit from "../components/forms/EquipmentModelEdit";
// import EquipmentEdit from "../components/forms/EquipmentEdit";
// import EquipmentNodeEdit from "../components/forms/EquipmentNodeEdit";
// import EquipmentParameterEdit from "../components/forms/EquipmentParameterEdit";

export const routes = [
  { name: 'main', path: '/', component: EquipmentListPage },

  //{ name: 'myEquipment', path: '/equipment/my', component: MyEquipmentPage },
  { name: 'allEquipment', path: '/equipment/all', component: EquipmentListPage },
  //{ name: 'favEquipment', path: '/equipment/fav', component: EquipmentListPage },
  { name: 'workRequests', path: '/workrequests/all', component: WorkRequestsListPage },
  { name: 'workRequest', path: '/workrequests/:idapplication', component: WorkRequestPage },

  //{ name: 'main', path: process.env.BASE_URL, component: EquipmentTypes },
  { name: 'signin', path: '/signin', component: SignInPage },

  //Типы оборудования
  //{ name: 'equipmenttypes', path: '/equipment-types', component: EquipmentTypesListPage, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'editequipmenttype', path: '/equipment-types/:equipmentTypeId', component: EquipmentTypeEdit, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'addequipmenttype', path: '/equipment-types-new', component: EquipmentTypeEdit, meta: { needBreadcrumbs: true } },

  //Модели оборудования
  //{ name: 'equipmentmodelsbytype', path: '/models/:equipmentTypeId', component: EquipmentModelsListPage, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'editequipmentmodel', path: '/models/:equipmentTypeId/:equipmentModelId', component: EquipmentModelEdit, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'addequipmentmodel', path: '/models-new/:equipmentTypeId', component: EquipmentModelEdit, meta: { needBreadcrumbs: true } },

  //Узлы оборудования
  //{ name: 'editequipmentnode', path: '/nodes/:equipmentTypeId/:equipmentModelId/:equipmentNodeId', component: EquipmentNodeEdit, props: true },
  //{ name: 'addequipmentnode', path: '/nodes-new/:equipmentTypeId/:equipmentModelId', component: EquipmentNodeEdit, meta: { needBreadcrumbs: true }, props: true },

  //Параметры состояния оборудования
  //{ name: 'editequipmentparameter', path: '/parameters/:equipmentTypeId/:equipmentModelId/:equipmentParameterId', component: EquipmentParameterEdit, props: true },
  //{ name: 'addequipmentparameter', path: '/parameters-new/:equipmentTypeId/:equipmentModelId/', component: EquipmentParameterEdit, meta: { needBreadcrumbs: true }, props: true },

  //Оборудование
  //{ name: 'equipmentbymodel', path: '/equipment/:equipmentTypeId/:equipmentModelId', component: EquipmentListPageForInspections, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'editequipment', path: '/equipment/:equipmentTypeId/:equipmentModelId/:equipmentId', component: EquipmentEdit, meta: { needBreadcrumbs: true }, props: true },
  //{ name: 'addequipment', path: '/equipment-new/:equipmentTypeId/:equipmentModelId', component: EquipmentEdit, meta: { needBreadcrumbs: true }, props: true },

  //Осмотры
  // { name: 'inspections', path: '/inspections/:equipmentTypeId/:equipmentModelId/:equipmentId', component: InspectionsListPage, meta: { needBreadcrumbs: true }, props: true },
  // { name: 'inspectionsbyequipment', path: '/inspections/:equipmentId', component: InspectionsListPage, meta: { needBreadcrumbs: false }, props: true },
  // { name: 'allinspections', path: '/inspections', component: InspectionsListPage, meta: { needBreadcrumbs: false }, props: true },
  // { name: 'currentinspections', path: '/current-inspections', component: CurrentInspectionsListPage, meta: { needBreadcrumbs: false }, props: true },

  { name: 'equipment', path: '/:equipmentId', component: EquipmentPassportPage, props: true },
  { name: 'EquipmentAttachments', path: '/:equipmentId/attachments', component: EquipmentAttachments, props: true },
  { name: 'WorkRequestAttachments', path: '/workrequests/:workRequestId/attachments', component: WorkRequestAttachments, props: true },
  // { name: 'InspectionAttachments', path: '/inspections/:inspectionId/attachments', component: InspectionAttachments, props: true },
  { path: '*', redirect: '/' }
]
